import './shared'
import 'slick-carousel';
import { bootstrap } from './shared';
import Swal from 'sweetalert2'
import '../css/sweetalert2.min.css'




let journeyFour = ["slide1"];

function addVisitedClass(item) {
    var visitedLink = document.getElementById(item);
    if (visitedLink) {
        visitedLink.classList.add("visited");
    }
}

$(window).on("load", function () {
    var journeyHistory = getCookie("journeyFour");
    if (journeyHistory && journeyHistory.length > 0) {
        journeyFour = journeyHistory;
        journeyFour.map((item) => {
            return addVisitedClass(item);
        });
    }
});


function changeSlide(slideNum) {
    console.log("start");
    var offcanvasElement = document.getElementById('offcanvasDarkNavbar');
    var bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement);
    if (bsOffcanvas != null) bsOffcanvas.hide();
    var clickedLink = `slide` + slideNum;
    if (!journeyFour.includes(clickedLink)) {
        journeyFour.push(clickedLink);
    }
    createCookie("journeyFour", journeyFour, 30);
    console.log("end");
    journeyFour.map((item) => {
        return addVisitedClass(item);
    });
    return pageContent.slideTo(slideNum - 1);
}


// To make it accessible globally
window.changeSlide = changeSlide;





$(".faq-selector").on("click", function () {
    //first hide all other div
    $(".faq-title").hide();
    $(".faq-desc").hide();
    var idBtn = $(this).data("id");
    //now open the selected div
    $("#title_" + idBtn).css("display", "flex");
    $("#desc_" + idBtn).css("display", "flex");
});
function showDetails() {
    $("#faqList").hide();
    $("#faqDetails").show();

    //show selected category
    $(".faq-title").hide();
    $(".faq-desc").hide();
    var idBtn = $(this).data("id");
    //now open the selected div
    $("#title_" + idBtn).css("display", "flex");
    $("#desc_" + idBtn).css("display", "flex");

    $("html, body").animate(
        {
            scrollTop: 0,
        },
        1000
    );

    //initialize categories slider
    $(".faq-slider").slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        rtl: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $('.slick-arrow').on('click', () => {
        setTimeout(() => {
            $('.slick-active').find('button').click()
        }, 500);
    })
}


// To make it accessible globally
window.showDetails = showDetails;



// Data from the tables
const ageData = [{ "age": "48 سنة و (6) أشهر فأكثر", "retirementAge": " 58 سنة ميلادية، وهي ما تعادل (60) سنة هجرية" }, { "age": "(48) سنة فأكثر، وأقل من (48) و (6) أشهر", "retirementAge": "58 سنة ميلادية و 4 أشهر" }, { "age": "(47) سنة فأكثر، وأقل من (48)", "retirementAge": "58 سنة ميلادية و 8 أشهر" }, { "age": "(46) سنة فأكثر، وأقل من (47)", "retirementAge": "59 سنة ميلادية" }, { "age": "(45) سنة فأكثر، وأقل من (46)", "retirementAge": "59 سنة ميلادية و 4 أشهر" }, { "age": "(44) سنة فأكثر، وأقل من (45)", "retirementAge": "59 سنة ميلادية و 8 أشهر" }, { "age": "(43) سنة فأكثر، وأقل من (44)", "retirementAge": "60 سنة ميلادية" }, { "age": "(42) سنة فأكثر، وأقل من (43)", "retirementAge": "60 سنة ميلادية و 4 أشهر" }, { "age": "(41) سنة فأكثر، وأقل من (42)", "retirementAge": "60 سنة ميلادية و 8 أشهر" }, { "age": "(40) سنة فأكثر، وأقل من (41)", "retirementAge": "61 سنة ميلادية" }, { "age": "(39) سنة فأكثر، وأقل من (40)", "retirementAge": "61 سنة ميلادية و 4 أشهر" }, { "age": "(38) سنة فأكثر، وأقل من (39)", "retirementAge": "61 سنة ميلادية و 8 أشهر" }, { "age": "(37) سنة فأكثر، وأقل من (38)", "retirementAge": "62 سنة ميلادية" }, { "age": "(36) سنة فأكثر، وأقل من (37)", "retirementAge": "62 سنة ميلادية و 4 أشهر" }, { "age": "(35) سنة فأكثر، وأقل من (36)", "retirementAge": "62 سنة ميلادية و 8 أشهر" }, { "age": "(34) سنة فأكثر، وأقل من (35)", "retirementAge": "63 سنة ميلادية " }, { "age": "(33) سنة فأكثر، وأقل من (34)", "retirementAge": "63 سنة ميلادية و 4 أشهر" }, { "age": "(32) سنة فأكثر، وأقل من (33)", "retirementAge": "63 سنة ميلادية و 8 أشهر" }, { "age": "(31) سنة فأكثر، وأقل من (32)", "retirementAge": "64 سنة ميلادية" }, { "age": "(30) سنة فأكثر، وأقل من (31)", "retirementAge": "64 سنة ميلادية و 4 أشهر" }, { "age": "(29) سنة فأكثر، وأقل من (30)", "retirementAge": "64 سنة ميلادية و 8 أشهر" }, { "age": "أقل من 29 سنة ميلادية", "retirementAge": " 65 سنة ميلادية" }];
const subscriptionData = [
    { "requiredDuration": "(300) شهراً، ما يعادل 25 سنة", "duration": " (240)  شهراً وأكثر" },
    { "requiredDuration": "(300) شهراً، ما يعادل 25 سنة", "duration": "من (228) شهراً إلى (239) شهراً" },
    { "requiredDuration": "(312) شهراً، ما يعادل 26 سنة", "duration": "من (216) شهراً إلى (227) شهراً" },
    { "requiredDuration": "(324) شهراً، ما يعادل 27 سنة", "duration": "من (204) شهراً إلى (215) شهراً" },
    { "requiredDuration": "(336) شهراً، ما يعادل 28 سنة", "duration": "من (192) شهراً إلى (203) شهراً" },
    { "requiredDuration": "(348) شهراً، ما يعادل 29 سنة", "duration": "من (180) شهراً إلى (191) شهراً" },
    { "requiredDuration": "(360) شهراً، ما يعادل 30 سنة", "duration": "(179) شهراً وأقل " }
];


// Function to populate dropdowns
function populateDropdowns() {
    const ageSelect = document.getElementById("currentAge");
    const durationSelect = document.getElementById("subscriptionDuration");

    // Adding placeholder options
    addPlaceholderOption(ageSelect, "اختر العمر الحالي...");
    addPlaceholderOption(durationSelect, "حدد مدة الاشتراك...");

    ageData.forEach(item => {
        let option = document.createElement("option");
        option.value = item.age;
        option.text = item.age;
        ageSelect.appendChild(option);
    });

    subscriptionData.forEach(item => {
        let option = document.createElement("option");
        option.value = item.duration;
        option.text = item.duration;
        durationSelect.appendChild(option);
    });
}

// Helper function to add placeholder option
function addPlaceholderOption(selectElement, placeholderText) {
    let placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.text = placeholderText;
    placeholder.disabled = true;
    placeholder.selected = true;
    selectElement.appendChild(placeholder);
}

// Function to calculate retirement
function calculateRetirement() {
    const selectedAge = document.getElementById("currentAge").value;
    const selectedDuration = document.getElementById("subscriptionDuration").value;
    const validationMsg = document.getElementById("validationMsg");

    // Check if both selections are made
    if (!selectedAge || !selectedDuration) {
        validationMsg.innerText = "يرجى تحديد السن ومدة الاشتراك.";
        return;
    } else if (selectedAge || selectedDuration) {
        validationMsg.innerText = "";
    }

    let retirementAge = ageData.find(item => item.age === selectedAge)?.retirementAge;
    let requiredDuration = subscriptionData.find(item => item.duration === selectedDuration)?.requiredDuration;
    let duration = subscriptionData.find(item => item.duration === selectedDuration)?.duration;
    console.log(duration);
    console.log('requiredDuration b4', requiredDuration);
    console.log('retirementAge b4', retirementAge);
    if (retirementAge === " 58 سنة ميلادية، وهي ما تعادل (60) سنة هجرية") {
        requiredDuration = "(300) شهراً، ما يعادل 25 سنة";
    } else if (duration === " (240)  شهراً وأكثر") {
        retirementAge = " 58 سنة ميلادية، وهي ما تعادل (60) سنة هجرية";
    }
    else {
        requiredDuration = subscriptionData.find(item => item.duration === selectedDuration)?.requiredDuration;
        retirementAge = ageData.find(item => item.age === selectedAge)?.retirementAge;
    }

    //const retirementStatus = (selectedDuration === subscriptionData[0]['duration'] || selectedAge === ageData[0]['age'])? "غير مشمول بتعديلات النظام الجديد":"غمشمول بتعديلات النظام الجديد";

    Swal.fire({
        icon: "success",
        html: `
        <div id="calculateRetirementResult">
            <div class="title">المدة المطلوبة للتقاعد المبكر: </div>
            <p>${requiredDuration}</p>
            <div class="title">سن التقاعد النظامي: </div>
            <p>${retirementAge}</p>
        </div>
        `,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: 'إلغاء',
        customClass: {
            confirmButton: 'btn', // Custom class for the confirm button
            cancelButton: 'btn'   // Custom class for the cancel button
        }
    })
}
$(window).on("load", function () {
    populateDropdowns()

    $("#calculateRetirementBtn").on("click", function () {
        calculateRetirement()
    })
})



//close video
const modal = document.getElementById('postModal-vid1');
const iframe = document.getElementById('iframe-vid1');
const player = new Vimeo.Player(iframe);

modal.addEventListener('hide.bs.modal', () => {
    player.pause();
});


const modal2 = document.getElementById('postModal-vid2');
const iframe2 = document.getElementById('iframe-vid2');
const player2 = new Vimeo.Player(iframe2);

modal2.addEventListener('hide.bs.modal', () => {
    player2.pause();
});

const modal3 = document.getElementById('postModal-vid3');
const iframe3 = document.getElementById('iframe-vid3');
const player3 = new Vimeo.Player(iframe3);

modal3.addEventListener('hide.bs.modal', () => {
    player3.pause();
});

const modal4 = document.getElementById('postModal-vid4');
const iframe4 = document.getElementById('iframe-vid4');
const player4 = new Vimeo.Player(iframe4);

modal4.addEventListener('hide.bs.modal', () => {
    player4.pause();
});

const modal7 = document.getElementById('postModal-vid7');
const iframe7 = document.getElementById('iframe-vid7');
const player7 = new Vimeo.Player(iframe7);
 
modal7.addEventListener('hide.bs.modal', () => {
    player7.pause();
});

// setTimeout(() => {
//
// }, 1000);


// const swiper = new Swiper('.swiper',{

// }); 



